import { SecureRandomSource } from "../classes/misc/secure-random-source";

/**
 * <csp:footer/> is required on the page in order to use this logic. AjaxLogoff form
 * submits Logoff.act. This code additionally appends the 'docUrl' attribute which
 * helps in smart-redirect after logout timeout.
 */
export function forceLogoutFromAjaxLogoff() {
    if (!document.AjaxLogoff || !document.AjaxLogoff.docUrl)
        throw new Error("missing AjaxLogoff form");

    document.AjaxLogoff.docUrl.value = document.location.pathname + window.location.search;
    document.AjaxLogoff.submit();
}

export function toggleRequirements() {
    const VISIBLE = "block";
    const HIDDEN = "none";

    const elm = document.getElementById("note");
    if (elm) {
        elm.style.display = elm.style.display === VISIBLE ? HIDDEN : VISIBLE;
    }
}

export function removeCharacterFromString(theString, theChar) {
    const splitString = theString.split(theChar);
    const numSplits = splitString.length;
    if (numSplits === 1) {
        return splitString[0];
    } else if ( numSplits === 2) {
        return splitString[0] + splitString[1];
    } else {
        let newString = "";
        for (let i = 0; i < numSplits; i++) {
            newString += splitString[i];
            if (i > 1) {
                newString += theChar; // add back the matching character because it appeared more than once.
            }
        }
        return newString;
    }
}

export function CA_genSpecials(randSrc, howMany, chars) {
    return randSrc.randString(chars, howMany);
}

export function CA_genNumbers(randSrc, howMany) {
    return randSrc.randString("0123456789", howMany);
}

export function CA_genLowercase(randSrc, howMany) {
    return randSrc.randString("abcdefghiklmnopqrstuvwxyz", howMany);
}

export function CA_genUppercase(randSrc, howMany) {
    return randSrc.randString("ABCDEFGHIJKLMNOPQRSTUVWXYZ", howMany);
}

export function CA_genAlphas(randSrc, howMany) {
    return randSrc.randString("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghiklmnopqrstuvwxyz", howMany);
}

export function CA_autoGen(usePassExpir, minUpperCaseCount, minLowerCaseCount, minNumberCount, minSpecialCount, minPasswordLength, specialCharsEscaped) {
    //Note: as of 9.0 minPasswordLength applies even when usePassExpir is false
    const randSrc = new SecureRandomSource();

    if (usePassExpir) {
        var newPass = "";
        // get number of uppercase
        newPass = CA_genUppercase(randSrc, minUpperCaseCount);

        // get number of lowercase
        newPass += CA_genLowercase(randSrc, minLowerCaseCount);

        // get number of numbers
        newPass += CA_genNumbers(randSrc, minNumberCount);

        // get number of specials
        newPass += CA_genSpecials(randSrc, minSpecialCount, specialCharsEscaped);

        // get password length
        if ( newPass.length < minPasswordLength )
        {
            newPass += randomString(randSrc, minPasswordLength - newPass.length);
        }

        newPass = randSrc.shuffleString(newPass);

        return newPass;
    } else {
        //Force at least 8 chars even if min is lesser.
        //8 lower case is stronger than the 6 mixed, and easier to type and remember.
        let nRandCharsNeeded = minPasswordLength;
        if (nRandCharsNeeded < 8)
            nRandCharsNeeded = 8;

        //A dot every four characters helps with visual and mental chunking
        newPass = '';
        let n;
        while (nRandCharsNeeded > 0) {
            if (newPass.length > 0)
                newPass += '.';
            n = nRandCharsNeeded > 4 ? 4 : nRandCharsNeeded;
            newPass += CA_genLowercase(randSrc, n);
            nRandCharsNeeded -= n;
        }

        return newPass;
    }
}

export function randomString(randSrc, howMany) {
    const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghiklmnopqrstuvwxyz";
    return randSrc.randString(chars, howMany);
}